// extracted by mini-css-extract-plugin
module.exports = {"section":"_3F0Wf","list":"_1RR_I","listItem":"_2sJKT","firstTier":"_3vVV4","secondTier":"KA1ta","listItemImg":"_1COo6"};